var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "navbar navbar-expand-lg navbar-light py-2" },
    [
      _c("span", { staticClass: "navbar-brand" }, [
        _c("img", {
          attrs: {
            alt: _vm.headerLogoAlt,
            height: _vm.headerLogoHeight,
            src: _vm.headerLogoSrc,
            width: _vm.headerLogoWidth
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }